module.exports = __webpack_public_path__ + "img/hlaponinstar.e53e38b0.jpg";